export default __webpack_public_path__ + "static/media/logo-no-eid.a9f174a0.png";